import flatpickr from 'flatpickr';
import { getDatePickerLocale } from 'client/javascript/date_picker/localization';
import { logError } from 'client/javascript/util/logger';

export const isEmailAddressValid = userInput => {
  return /^.+@.+\..+$/.test(userInput);
};

export const convertDiscountToPercentage = (type, discount) => {
  if (type === 'percent') {
    return parseFloat(discount) * 100;
  }
};

export async function initDatePicker({ element, onChange, defaultDate }) {
  try {
    const locale = await getDatePickerLocale();

    return flatpickr(element, {
      onChange,
      minDate: 'today',
      defaultDate,
      inline: true,
      nextArrow: '➝',
      prevArrow: '➝', // no matching unicode left arrow to this one, flipped using CSS
      locale
    });
  } catch (error) {
    logError('Failed initDatePicker', error);
    return null;
  }
}
